import React from 'react';
import {useAIToolsContext} from "../../../../../../../../context/AIToolsProvider";
import {AITools} from "../../../../../../../../constant";
import HighlightAndSwapActions from "./HighlightAndSwapActions";
import {useImageEditorContext} from "../../../../../../../../context/ImageEditorProvider";
import ImageEditorActions from "./ImageEditorActions";
import {styled} from "@mui/material/styles";

const Description = styled('span')({
  marginTop: 10,
  fontWeight: '500',
  color: '#646666'
})

const ADSPlaygroundContentActions = () => {
  const {selectedAITools} = useAIToolsContext();
  const {isEditingImage} = useImageEditorContext();

  if (isEditingImage) {
    return <ImageEditorActions/>
  }

  switch (selectedAITools) {
    case AITools.HighlightAndSwap:
    case AITools.HighlightAndSwap2:
    case AITools.HighlightAndRemove: {
      return <HighlightAndSwapActions/>
    }

    case AITools.RemoveBackground:
      return <Description>Select or upload an image, then click Generate to remove the background.</Description>

    case AITools.BlurBackground:
      return <Description>Select or upload an image, then click Generate to create a blur background.</Description>

    case AITools.SwapFace:
      return <Description>Upload two images, select the faces to swap, and click Generate.</Description>

    case AITools.FaceCorrection:
      return <Description>Select or upload an image, then choose the face you want to correct, and click Generate.</Description>

    case AITools.AvatarConverter:
    default: {
      return null
    }
  }
};

export default ADSPlaygroundContentActions;
